import { WorkingStatusSettings } from '@components/settings/WorkingStatusSettings';

import {
  useUpdateWorkStatusMutation,
  useWorkingStatusSettingQuery,
} from './graphql.v3.generated';

type WorkingStatusSettingsContainerProps = {
  className?: string
};

export const WorkingStatusSettingsContainer: React.FC<WorkingStatusSettingsContainerProps> = ({
  className,
}) => {
  const { data } = useWorkingStatusSettingQuery({
    context: { batch: true },
  });
  const [updateWorkStatus] = useUpdateWorkStatusMutation({
    optimisticResponse: data
      ? ({ iAmWorking }) => ({
        updateWorkStatus: {
          user: {
            id: data.viewer.id,
            isWorking: iAmWorking,
            __typename: 'User',
          },
          errors: null,
          __typename: 'UpdateWorkStatus',
        },
      })
      : undefined,
  });

  if (!data) {
    return null;
  }

  return (
    <WorkingStatusSettings
      className={className}
      isUserWorking={data.viewer.isWorking}
      onChange={(isUserWorking) => updateWorkStatus({
        variables: { iAmWorking: isUserWorking },
      })}
    />
  );
};
